import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import {Favorite} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'

import {useFragment} from 'react-relay'

import useAtmosphere from '../../hooks/useAtmosphere'
import useMutationProps from '../../hooks/useMutationProps'
import ToggleFavoriteTemplateMutation from '../../mutations/ToggleFavoriteTemplateMutation'
import {cn} from '../../ui/cn'
import {Tooltip} from '../../ui/Tooltip/Tooltip'
import {TooltipContent} from '../../ui/Tooltip/TooltipContent'
import {TooltipTrigger} from '../../ui/Tooltip/TooltipTrigger'







const ActivityCardFavorite = (props) => {
  const {className, templateId, viewerRef} = props
  const atmosphere = useAtmosphere()
  const {onError, onCompleted} = useMutationProps()

  const viewer = useFragment(
    graphql`
      fragment ActivityCardFavorite_user on User {
        favoriteTemplates {
          id
        }
      }
    `,
    viewerRef
  )
  const favoriteTemplateIds = viewer.favoriteTemplates.map((template) => template.id)
  const isFavorite = favoriteTemplateIds.includes(templateId)
  const tooltipCopy = isFavorite ? 'Remove from favorites' : 'Add to favorites'

  const handleClick = (e) => {
    e.preventDefault()
    ToggleFavoriteTemplateMutation(atmosphere, {templateId}, {onError, onCompleted})
  }

  return (
    _jsxs(Tooltip, { children: [
      _jsx('div', {
        className: cn(
          className,
          `flex h-10 w-10 items-center justify-center rounded-full bg-white`
        ),
 children: 
        _jsx(TooltipTrigger, { asChild: true, children: 
          _jsx('button', {
            onClick: handleClick,
            className: "flex h-full w-full cursor-pointer items-center justify-center bg-transparent"      ,
 children: 
            _jsx(Favorite, { className: isFavorite ? 'text-rose-600' : 'text-slate-600',} )
          })
        })
      })
      , _jsx(TooltipContent, { side: "bottom", align: "center", sideOffset: 20, children: 
        tooltipCopy
      })
    ]})
  )
}

export default ActivityCardFavorite
